<template>
  <div class="code">
    <h4 class="text-center p-2">{{ $t('company-code.company-code-title') }}</h4>

    <div class="rc-datetime"></div>
    <div class="code-info">
      <div class="group-btn">
        <router-link tag="button" :to="{ name: 'company-qrscan' }">
          <v-btn
            id="btn-scan"
            color="#e8320d"
            height="70"
            v-html="
              $t('company-code.btn-use-qr', {
                split: '<br />'
              })
            "
          >
          </v-btn>
        </router-link>
        <div class="margin" style="padding-top: 50px">
          <router-link tag="button" :to="{ name: 'company-codescan' }">
            <v-btn
              id="btn-code"
              color="#e8320d"
              height="70"
              v-html="
                $t('company-code.btn-use-code-manual', {
                  split: '<br />'
                })
              "
            >
            </v-btn>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionScan'
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';
@import '@/style/devices.scss';
h4 {
  padding: 2rem 2rem 0 2rem;
}
.group-btn {
  height: 30rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .v-btn {
    width: 350px;
    color: #fff;
    text-transform: unset !important;
  }
  .btn-code {
    margin-top: 0 !important;
  }
  .orderCode {
    color: #fff;
    width: 85%;
    height: 70px;
    font-weight: 900;
    font-size: 40px;
  }

  .title {
    font-weight: 500;
    font-size: 14px !important;
    margin-top: 40px;
    text-align: center;
  }

  .qr-box {
    overflow: hidden;
    background: #fff;
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    width: 50%;
    img {
      width: 100%;
    }
  }
}

@include mobile {
  .group-btn {
    height: auto !important;
    .margin {
      padding-top: 1.8rem !important;
    }
    #btn-code,
    #btn-scan {
      width: 13rem !important;
      height: 50px !important;
      font-size: 10px !important;
      color: #fff;
    }
    #btn-code {
      margin-bottom: 1.5rem;
    }
  }
}
</style>
